import { render, staticRenderFns } from "./ProductSwatches.vue?vue&type=template&id=85f6abae&scoped=true"
import script from "./ProductSwatches.vue?vue&type=script&lang=ts"
export * from "./ProductSwatches.vue?vue&type=script&lang=ts"
import style0 from "./ProductSwatches.vue?vue&type=style&index=0&id=85f6abae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f6abae",
  null
  
)

export default component.exports